import React from 'react';
import PropTypes from 'prop-types';
import Typography, {TypeVariants} from '@urbanmassage/component-library/lib/Typography/Typography';

class Alert extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['success', 'error']).isRequired,
    title: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const {
      type, title, text, className, ...rest
    } = this.props;
    return (
      <div
        {...rest}
        className={`alert alert--${type} ${className || ''}`}>
        <div className="alert__body">
          {title ? (
            <Typography
              className="alert__title"
              variant={TypeVariants.body}
              theme="white"
            >
              {title}
            </Typography>
          ) : null}
          {text ? (
            <Typography
              className="alert__title"
              variant={TypeVariants.body}
              theme="white"
            >
              {text}
            </Typography>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./spa/Components/Alert.jsx